export default{
    doctor:{
        doctor: 'Doctor',
        patient: 'Patient',
        createdAt: 'Created At',
        receptionType: 'Reception Type',
        service: 'Service',
        insurance: 'Insurance',
        tax: 'Tax',
        doctorTax: 'Doctor Tax',
        hospitalTax: 'Hospital Tax',
        doctorDiscountShare: 'Doctor Discount Share',
        hospitalDiscountShare: 'Hospital Discount Share',
        totalAmount: 'Total Amount',
        doctorShare: 'Doctor Share',
        hospitalShare: 'Hospital Share',
        fromDate: 'From Date',
        toDate: 'To Date',
    },
    unit:{
        doctor: 'پزشک',
        patient: 'بیمار',
        createdAt: 'تاریخ',
        receptionType: 'علت مراجعه',
        insurance: 'بیمه',
        tax: 'مالیات',
        doctorTax: 'مالیات پزشک',
        hospitalTax: 'مالیات مرکز',
        doctorDiscountShare: 'تخفیف پزشک',
        hospitalDiscountShare: 'تخفیف مرکز',
        doctorReturnShare: 'استرداد پزشک',
        hospitalReturnShare: 'استرداد مرکز',
        totalAmount: 'مبلغ',
        doctorShare: 'سهم پزشک',
        hospitalShare: 'سهم مرکز',
        fromDate: 'از تاریخ',
        toDate: 'تا تاریخ',
        serviceCategory:'نوع خدمت',
        services: 'خدمات',
        unit:'کلینیک',
        createdUser: 'پذیرش کننده',
        referralWay: 'نحوه‌ی آشنایی',
        service: {
            serviceName: 'عنوان',
            total: 'مبلغ',
            beneficiaryDoctor: 'پزشک',
        },
        payments: 'پرداخت ها',
        payment: {
            paymentMethod: 'نوع',
            amount: 'مبلغ',
            createdUser: 'صندوقدار',
            createdAt: "createdAt",

        },
        averageWaitingTime: 'متوسط زمان انتظار بیمار',
        averageVisitTime: 'متوسط زمان ویزیت بیمار',

    },
    cashier:{
        cashierReport: 'گزارش صندوق',
        cashier: 'صندوقدار',
        patient: 'بیمار',
        createdAt: 'تاریخ',
        // receptionType: 'علت مراجعه',
        services: 'خدمات',
        service: {
            serviceName: 'عنوان',
            total: 'مبلغ',
            beneficiaryDoctor: 'پزشک',
        },
        payments: 'پرداخت ها',
        payment: {
            paymentMethod: 'نوع',
            amount: 'مبلغ',
            createdAt: 'تاریخ پرداخت',
        },
        // insurance: 'بیمه',
        // tax: 'مالیات',
        // doctorTax: 'مالیات پزشک',
        // hospitalTax: 'مالیات مرکز',
        // doctorDiscountShare: 'تخفیف پزشک',
        // hospitalDiscountShare: 'تخفیف مرکز',
        // totalAmount: 'مبلغ',
        // doctorShare: 'سهم پزشک',
        // hospitalShare: 'سهم مرکز',
        fromDate: 'از تاریخ',
        toDate: 'تا تاریخ',
        fromTime: 'از ساعت',
        toTime: 'تا ساعت',
        paymentsSum: 'مجموع پرداخت ها',

    },
    return:{
        return: 'استرداد',
        returnAmount: 'مبلغ استرداد',
        patient: 'بیمار',
        createdAt: 'تاریخ',
        unit: 'واحد',
        // receptionType: 'علت مراجعه',
        // services: 'خدمات',
        // service: {
        //     serviceName: 'عنوان',
        //     total: 'مبلغ',
        //     beneficiaryDoctor: 'پزشک',
        // },
        // payments: 'پرداخت ها',
        // payment: {
        //     paymentMethod: 'نوع',
        //     amount: 'مبلغ',
        // },
        description: 'علت استرداد',
        fromDate: 'از تاریخ',
        toDate: 'تا تاریخ',
    }
}